/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

const ANALYTICS_ERROR_BASE = 0x0800;

/**
 * Collection of analytics error codes.
 */
export const AnalyticsErrorCodes = Object.freeze({
  /**
   * Indicates that the analytics session initialization failed.
   */
  SESSION_INIT_FAILURE: ANALYTICS_ERROR_BASE + 0x01,
  /**
   * Indicates that the playback session initialization failed.
   */
  PLAYBACK_INIT_FAILURE: ANALYTICS_ERROR_BASE + 0x02,
  /**
   * Indicates that an attempt was made to report a custom event
   * with the name that is already reserved.
   */
  EVENT_NAME_ALREADY_RESERVED: ANALYTICS_ERROR_BASE + 0x03,
  /**
   * Indicates that the analytics reporter is not initialized.
   */
  ANALYTICS_REPORTER_NOT_INITIALIZED: ANALYTICS_ERROR_BASE + 0x04,
  /**
   * The error to notify failures on initialising Datazoom Analytics.
   */
  DATAZOOM_ANALYTICS_INITIALIZATION_FAILURE: ANALYTICS_ERROR_BASE + 0x05,
  /**
   *  The error to notify failures on initialising Conviva Analytics.
   */
  CONVIVA_ANALYTICS_INITIALIZATION_FAILURE: ANALYTICS_ERROR_BASE + 0x06,
  /**
   *  The error to notify failures on initialising NPAW Analytics.
   */
  NPAW_ANALYTICS_INITIALIZATION_FAILURE: ANALYTICS_ERROR_BASE + 0x0b,
  /**
   * The error to notify failures on initialising New Relic Analytics.
   * Reserved error codes for New Relic Analytics errors = 0x0808, 0x0809, 0x080A.
   */
  NEW_RELIC_ANALYTICS_INITIALIZATION_FAILURE: ANALYTICS_ERROR_BASE + 0x08,
  /**
   * The error to notify failures on initialising Godavari Analytics.
   */
  GODAVARI_ANALYTICS_INITIALIZATION_FAILURE: ANALYTICS_ERROR_BASE + 0x0c,
});
